import { render, staticRenderFns } from "./ViewOffice.vue?vue&type=template&id=d12ef764&scoped=true&"
import script from "./ViewOffice.vue?vue&type=script&lang=js&"
export * from "./ViewOffice.vue?vue&type=script&lang=js&"
import style0 from "./ViewOffice.vue?vue&type=style&index=0&id=d12ef764&prod&scoped=true&lang=css&"
import style1 from "./ViewOffice.vue?vue&type=style&index=1&id=d12ef764&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12ef764",
  null
  
)

export default component.exports